<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>bookmark</mat-icon>
        {{ 'trackers.apply_template_title' | translate }}
        <span *ngIf="trackerName" class="picker-target">{{'trackers.apply_template_for_device'|translate:{name: trackerName} }}</span>
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <input class="search-input" type="text" [ngModel]="searchText" (ngModelChange)="onSearchChange($event)"
        placeholder="{{'search'|translate}}" />

    <div class="template-list" *ngIf="!loading">
        <button type="button" class="template-item" *ngFor="let config of displayedConfigs" (click)="select(config)">
            <span class="template-name">{{ config.name }}</span>
            <span class="type-chip">{{ config.type }}</span>
        </button>

        <p class="no-templates" *ngIf="!displayedConfigs.length">{{'menu.devices.configs.no_templates'|translate}}</p>
    </div>
</mat-dialog-content>
